import * as i0 from '@angular/core';
import { inject, ElementRef, Directive, Input, HostListener } from '@angular/core';
import { checkTimeout } from '@js-dot/core';
class FlashComponentBase {
  componentRef;
  timeout;
  display;
  color;
  _node;
  _flashDestroyTimer;
  _selfClose = this._flashClose.bind(this);
  constructor() {
    this._node = inject(ElementRef).nativeElement;
  }
  ngOnInit() {
    this.flashOnInit();
  }
  flashOnInit() {
    if (this.display) {
      this._flashSetDestroyTimer();
    }
  }
  ngOnChanges(changes) {
    for (let key in changes) {
      {
        if (changes.hasOwnProperty(key)) {
          this[key] = changes[key].currentValue;
        }
      }
    }
    this.flashOnInit();
  }
  _flashOnMouseEnter() {
    checkTimeout(this._flashDestroyTimer);
  }
  _flashOnMouseLeave() {
    this._flashSetDestroyTimer();
  }
  _flashSetDestroyTimer() {
    const {
      timeout
    } = this;
    if (timeout !== undefined && !timeout || timeout < 0) {
      return;
    }
    this._flashDestroyTimer = checkTimeout(this._flashDestroyTimer, this._selfClose, timeout || 8000);
  }
  _flashClose() {
    checkTimeout(this._flashDestroyTimer);
  }
  static ɵfac = function FlashComponentBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FlashComponentBase)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FlashComponentBase,
    hostBindings: function FlashComponentBase_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mouseenter", function FlashComponentBase_mouseenter_HostBindingHandler() {
          return ctx._flashOnMouseEnter();
        })("mouseleave", function FlashComponentBase_mouseleave_HostBindingHandler() {
          return ctx._flashOnMouseLeave();
        });
      }
    },
    inputs: {
      color: "color",
      componentRef: "componentRef",
      timeout: "timeout",
      display: "display"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FlashComponentBase, [{
    type: Directive,
    args: [{
      inputs: ['color'],
      standalone: false
    }]
  }], () => [], {
    componentRef: [{
      type: Input
    }],
    timeout: [{
      type: Input
    }],
    display: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    _flashOnMouseEnter: [{
      type: HostListener,
      args: ['mouseenter']
    }],
    _flashOnMouseLeave: [{
      type: HostListener,
      args: ['mouseleave']
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FlashComponentBase };
